module.exports = __webpack_public_path__ + "media/images/expert__jeff-baltermia-010b8f89551571fd8f369af6e6c0d8dc.png";